import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { isPublicRoute } from './shared/public-routes';
import {
  ASSISTANT_QUERY_URL,
  ASSISTANT_SUGGEST_URL,
  AssistantResponseType,
} from './shared/assistant-endpoints';
import { AuthService } from './services/auth/auth.service';
import { UserModeService } from './services/customs/user-mode/user-mode.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'truckit_business_fe';
  isCollapsed = true;
  isChatOpen = false;
  hasOpenedChat = false;
  userName = '';
  providerId = 0;

  readonly assistantQueryUrl = ASSISTANT_QUERY_URL;
  readonly assistantSuggestUrl = ASSISTANT_SUGGEST_URL;
  /** Sidebar chat — use `filters` on listing-search surfaces when that UI is added. */
  readonly assistantResponseType: AssistantResponseType = 'agentic';

  constructor(
    public router: Router,
    private authService: AuthService,
    private userModeService: UserModeService,
  ) {}

  ngOnInit(): void {
    this.userModeService.mode$.subscribe((mode) => {
      if (mode !== 'provider') {
        this.closeChat();
      }
    });

    if (isPublicRoute() || this.router.url === '/style-guide') {
      return;
    }

    this.authService.getUser().subscribe({
      next: (res: any) => {
        this.userName = res.data?.firstname ?? '';
        this.providerId = Number(res.data?.provider_id) || 0;
      },
    });
  }

  public hiddenSidebarUrls: string[] = [
    '/view/proof-of-delivery/',
    '/access-denied',
  ];

  // URLs for which the header should be hidden
  public hiddenHeaderUrls: string[] = [
    '/view/proof-of-delivery/',
    '/access-denied',
  ];

  // Determine if the header should be hidden based on the current URL
  public isHeaderHidden(): boolean {
    return this.hiddenHeaderUrls.some((prefix) =>
      this.router.url.startsWith(prefix),
    );
  }

  public isSidebarHidden(): boolean {
    return this.hiddenSidebarUrls.some((prefix) =>
      this.router.url.startsWith(prefix),
    );
  }

  public isFullWidthPage(): boolean {
    const fullWidthPrefixes = ['/broker-manager', '/listings-and-bookings'];
    return fullWidthPrefixes.some((prefix) =>
      this.router.url.startsWith(prefix),
    );
  }

  // Pages that run edge-to-edge (no container side padding).
  public isEdgeToEdgePage(): boolean {
    const edgeToEdgePrefixes = ['/esg'];
    return edgeToEdgePrefixes.some(prefix => this.router.url.startsWith(prefix));
  }

  toggleSidebar(collapsed: boolean) {
    this.isCollapsed = collapsed;
  }

  get showAssistant(): boolean {
    return (
      !isPublicRoute() &&
      this.router.url !== '/style-guide' &&
      this.userModeService.currentMode === 'provider'
    );
  }

  openChat(): void {
    this.hasOpenedChat = true;
    this.isChatOpen = true;
  }

  closeChat(): void {
    this.isChatOpen = false;
  }
}
